import styled from "styled-components";

import { media } from "../../../../../../styles/media";

export const TeamRailStyles = styled.div`
  background: ${({ theme }) => theme.colors.semantic.container.white};
  border: 1px solid ${({ theme }) => theme.colors.primary[100]};
  border-radius: 12px;
  box-shadow: ${({ theme }) => theme.shadows.card};
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  transition: width 200ms ease;

  /* When stacked above the timeline on mobile, cap the rail height so it
     doesn't push the timeline off-screen; the list scrolls internally. And
     collapse it into a short horizontal bar (upward) instead of the desktop
     vertical left strip. */
  ${media.maxTablet`
    height: auto;
    max-height: 320px;

    .collapsed-strip {
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      height: auto;
      padding: 12px 14px;
      gap: 12px;

      .collapsed-label {
        writing-mode: horizontal-tb;
        transform: none;
        margin-top: 0;
      }
    }
  `}

  .collapsed-strip {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 14px;
    cursor: pointer;
    gap: 10px;

    .collapse-icon {
      width: 28px;
      height: 28px;
      border-radius: 8px;
      border: 1px solid ${({ theme }) => theme.colors.primary[100]};
      background: ${({ theme }) => theme.colors.semantic.background.white};
      display: grid;
      place-items: center;
      cursor: pointer;
      color: ${({ theme }) => theme.colors.primary[600]};
    }

    .collapsed-label {
      writing-mode: vertical-rl;
      transform: rotate(180deg);
      font-size: 11px;
      font-weight: 500;
      letter-spacing: 1px;
      text-transform: uppercase;
      color: ${({ theme }) => theme.colors.primary[600]};
      margin-top: 6px;
    }
  }

  .header {
    padding: 12px 14px 10px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.primary[100]};

    .header-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;

      .title {
        font-size: 13px;
        font-weight: 500;
        color: ${({ theme }) => theme.colors.semantic.text.strong};
      }

      .count {
        color: ${({ theme }) => theme.colors.primary[400]};
        font-weight: 400;
        margin-left: 4px;
      }

      .actions {
        display: flex;
        align-items: center;
        gap: 4px;
      }

      .all-btn {
        border: none;
        background: transparent;
        font-size: 11px;
        color: ${({ theme }) => theme.colors.accent[500]};
        cursor: pointer;
        font-weight: 500;
        padding: 4px 6px;
        font-family: inherit;
      }

      .collapse-btn {
        width: 24px;
        height: 24px;
        border-radius: 6px;
        border: 1px solid ${({ theme }) => theme.colors.primary[100]};
        background: ${({ theme }) => theme.colors.semantic.background.white};
        display: grid;
        place-items: center;
        cursor: pointer;
        color: ${({ theme }) => theme.colors.primary[500]};
      }
    }

    .search-box {
      height: 32px;
      border: 1px solid ${({ theme }) => theme.colors.primary[100]};
      border-radius: 6px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      gap: 8px;
      color: ${({ theme }) => theme.colors.primary[400]};

      input {
        border: none;
        outline: none;
        flex: 1;
        font-size: 12px;
        font-family: inherit;
        background: transparent;
        color: ${({ theme }) => theme.colors.semantic.text.strong};
      }
    }
  }

  .list {
    overflow: auto;
    flex: 1;
    padding: 4px 6px 6px;
  }

  .row {
    padding: 8px 10px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    background: transparent;
    margin-bottom: 2px;

    &.checked {
      background: ${({ theme }) => theme.colors.accent[50]};
    }
  }

  .checkbox {
    width: 15px;
    height: 15px;
    border-radius: 4px;
    border: 1.5px solid ${({ theme }) => theme.colors.primary[200]};
    background: ${({ theme }) => theme.colors.semantic.background.white};
    display: grid;
    place-items: center;
    color: ${({ theme }) => theme.colors.semantic.accent.onAccent};
    flex-shrink: 0;

    &.checked {
      border-color: ${({ theme }) => theme.colors.accent[500]};
      background: ${({ theme }) => theme.colors.accent[500]};
    }
  }

  .meta {
    flex: 1;
    min-width: 0;

    .name {
      font-size: 12.5px;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: ${({ theme }) => theme.colors.semantic.text.strong};
    }

    .sub {
      font-size: 10.5px;
      color: ${({ theme }) => theme.colors.primary[400]};
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .util {
    width: 30px;
    text-align: right;

    .pct {
      font-size: 10px;
      color: ${({ theme }) => theme.colors.primary[500]};
      margin-bottom: 3px;
      font-variant-numeric: tabular-nums;
    }

    .bar {
      height: 3px;
      background: ${({ theme }) => theme.colors.primary[100]};
      border-radius: 999px;
      overflow: hidden;
    }

    .fill {
      height: 100%;
      background: ${({ theme }) => theme.colors.accent[500]};

      &.high {
        background: ${({ theme }) => theme.colors.error[500]};
      }
      &.low {
        background: ${({ theme }) => theme.colors.success[600]};
      }
    }
  }

  .empty {
    padding: 16px 12px;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.primary[400]};
    text-align: center;
  }
`;
